
(function () {
  "use strict";

  function boot() {

  /* Scope every lookup to the guide root: .media/.modal/.grid/.lightbox/.active/.open are
     also used by the theme, so document-wide queries would reach theme elements. */
  var GG = document.querySelector(".gg-root");
  if (!GG || GG.dataset.ggReady) return;
  GG.dataset.ggReady = "1";
  var $  = function (s) { return GG.querySelector(s); };
  var $$ = function (s) { return GG.querySelectorAll(s); };

  /* Cart base URL — market/locale aware (/cart or /en-us/cart), injected by the section. */
  var CART_URL = (window.GG_CART_URL || "/cart").replace(/\/$/, "");

  /* Motion: the CSS reduce-block cannot reach scrolls that pass an explicit `behavior`,
     so every programmatic scroll goes through sb(). */
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)");
  function sb() { return RM.matches ? "auto" : "smooth"; }

  /* One debounced resize listener instead of ~87 (one per carousel/strip). */
  var RESIZE = [];
  window.addEventListener("resize", (function () {
    var t;
    return function () { clearTimeout(t); t = setTimeout(function () { RESIZE.forEach(function (f) { f(); }); }, 150); };
  })());

  /* Live product data. The build-time snapshot froze variant IDs and stock flags, so one drifted
     product 404'd the whole look's cart. The .piece hrefs are already market-correct
     (/en-us/products/...), so href + ".js" is locale-correct too. */
  var PCACHE = {};
  function getProduct(href) {
    if (!PCACHE[href]) {
      PCACHE[href] = fetch(href + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return PCACHE[href];
  }

  /* ---- keep --nav-h in sync with the real sticky bar height ---- */
  var topbar = $(".topbar");
  function syncNavH() {
    if (!topbar) return;
    GG.style.setProperty("--nav-h", topbar.offsetHeight + "px");
  }
  syncNavH();
  RESIZE.push(syncNavH);

  /* ---- carousels: build bars + dots, track scroll, arrow buttons ---- */
  $$(".media").forEach(function (media) {
    var car = media.querySelector("[data-carousel]");
    if (!car) return;
    var slides = car.querySelectorAll(".slide");
    var barsW = media.querySelector("[data-bars]");
    var dotsW = media.querySelector("[data-dots]");
    var prev = media.querySelector("[data-cprev]");
    var next = media.querySelector("[data-cnext]");

    // build indicators
    slides.forEach(function () {
      var b = document.createElement("span");
      b.className = "b";
      b.appendChild(document.createElement("i"));
      barsW.appendChild(b);
      var d = document.createElement("span");
      d.className = "d";
      dotsW.appendChild(d);
    });
    var bars = barsW.querySelectorAll(".b");
    var dots = dotsW.querySelectorAll(".d");

    var cur = 0, n = slides.length;
    function set(i) {
      cur = i;
      bars.forEach(function (b, k) { b.classList.toggle("on", k <= i); });
      dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
    }
    set(0);

    var raf;
    car.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        set(Math.round(car.scrollLeft / car.clientWidth));
      });
    }, { passive: true });

    function go(i) {                       // circular: wrap around both ends
      i = (i + n) % n;
      car.scrollTo({ left: i * car.clientWidth, behavior: sb() });
    }
    if (prev) prev.addEventListener("click", function () { go(cur - 1); });
    if (next) next.addEventListener("click", function () { go(cur + 1); });
  });

  /* ---- product ("The Pieces") strips: swipe on touch, arrows on desktop ---- */
  $$(".pieces-wrap").forEach(function (wrap) {
    var track = wrap.querySelector("[data-track]");
    var prev = wrap.querySelector("[data-pprev]");
    var next = wrap.querySelector("[data-pnext]");
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector(".piece");
      var w = card ? card.getBoundingClientRect().width + 12 : 140; // card + gap
      return Math.max(w, Math.round(track.clientWidth * 0.8));
    }
    function update() {
      var overflow = track.scrollWidth - track.clientWidth > 2;
      // hide both arrows entirely when everything fits
      prev.style.display = next.style.display = overflow ? "" : "none";
      if (!overflow) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: sb() }); });
    next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: sb() }); });

    var raf;
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });
    RESIZE.push(update);
    update();
  });

  /* ---- lightbox ---- */
  var lb = $("#lightbox");
  if (!lb) return;
  var lbImg = lb.querySelector(".lb-img");
  var lbCount = lb.querySelector("[data-lbcount]");
  var lbList = [];
  var lbIdx = 0;
  var lastFocus = null;

  function lbRender() {
    lbImg.src = lbList[lbIdx].src;
    lbImg.alt = lbList[lbIdx].alt || "";
    lbCount.textContent = (lbIdx + 1) + " / " + lbList.length;
  }
  function lbOpen(list, idx) {
    lbList = list; lbIdx = idx;
    lastFocus = document.activeElement;
    lbRender();
    lb.hidden = false;
    document.body.classList.add("no-scroll");
    lb.querySelector("[data-lbclose]").focus();
  }
  function lbClose() {
    lb.hidden = true;
    document.body.classList.remove("no-scroll");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function lbStep(d) {
    lbIdx = (lbIdx + d + lbList.length) % lbList.length;
    lbRender();
  }

  // any container marked [data-gallery] becomes a zoomable group:
  // look carousels, product ("Pieces") strips, and category collages
  $$("[data-gallery]").forEach(function (group) {
    var imgs = [].slice.call(group.querySelectorAll("img"));
    imgs.forEach(function (img, i) {
      img.addEventListener("click", function () {
        lbOpen(imgs.map(function (x) { return { src: x.dataset.full || x.currentSrc || x.src, alt: x.alt }; }), i);
      });
    });
  });

  lb.querySelector("[data-lbclose]").addEventListener("click", lbClose);
  lb.querySelector("[data-lbprev]").addEventListener("click", function () { lbStep(-1); });
  lb.querySelector("[data-lbnext]").addEventListener("click", function () { lbStep(1); });
  lb.addEventListener("click", function (e) {
    if (e.target === lb) lbClose();
  });
  document.addEventListener("keydown", function (e) {
    if (lb.hidden) return;
    if (e.key === "Escape") lbClose();
    else if (e.key === "ArrowLeft") lbStep(-1);
    else if (e.key === "ArrowRight") lbStep(1);
  });

  // swipe on lightbox
  var tx = null;
  lb.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener("touchend", function (e) {
    if (tx === null) return;
    var dx = e.changedTouches[0].clientX - tx;
    if (Math.abs(dx) > 45) lbStep(dx < 0 ? 1 : -1);
    tx = null;
  }, { passive: true });

  /* ---- active category in nav (IntersectionObserver) ---- */
  var links = {};
  $$("[data-navlink]").forEach(function (a) {
    links[a.getAttribute("data-navlink")] = a;
  });
  var cats = $$(".cat[data-cat]");
  if ("IntersectionObserver" in window && cats.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.getAttribute("data-cat");
        Object.keys(links).forEach(function (k) {
          links[k].classList.toggle("active", k === id);
        });
        var active = links[id];
        if (active && active.parentNode) {
          var nav = active.parentNode;
          var target = active.offsetLeft - nav.clientWidth / 2 + active.clientWidth / 2;
          nav.scrollTo({ left: target, behavior: sb() });
        }
      });
    }, { rootMargin: "-45% 0px -50% 0px", threshold: 0 });
    cats.forEach(function (c) { io.observe(c); });
  }


  /* ---- look "Show more": expands description; on mobile ALSO reveals the meta rows ---- */
  var mqMobile = window.matchMedia("(max-width:1023px)");
  $$(".lookinfo").forEach(function (info) {
    var desc = info.querySelector(".lookdesc");
    if (!desc) return;
    var b = document.createElement("button");
    b.className = "readmore lookmore";
    b.type = "button";
    b.textContent = "Show more";
    b.setAttribute("aria-expanded", "false");
    b.addEventListener("click", function () {
      var open = info.classList.toggle("open");
      b.textContent = open ? "Show less" : "Show more";
      b.setAttribute("aria-expanded", open ? "true" : "false");
    });
    desc.insertAdjacentElement("afterend", b); // button right under the short description
    function upd() {
      // mobile: rows are hidden -> always offer the button; desktop: only if desc overflows
      var need = mqMobile.matches || (desc.scrollHeight - desc.clientHeight > 2);
      b.style.display = (need || info.classList.contains("open")) ? "" : "none";
    }
    upd();
    RESIZE.push(upd);
  });

  /* ---- toast ---- */
  var toastEl = $("#toast"), toastT;
  var live = $(".gg-sr");
  function toast(msg){ if(live) live.textContent = msg;            /* announce to screen readers */
    if(!toastEl) return; toastEl.textContent=msg; toastEl.hidden=false;
    clearTimeout(toastT); toastT=setTimeout(function(){toastEl.hidden=true;},2200); }
  function openModal(el){ el.hidden=false; document.body.classList.add("no-scroll"); }
  function closeModal(el){ el.hidden=true; document.body.classList.remove("no-scroll"); }

  /* ---- Shop the Look modal (products + size selects -> cart) ---- */
  var shopM = $("#shopmodal");
  if (shopM) {
    var mBody = shopM.querySelector(".modal-body");
    var mAdd = shopM.querySelector(".modal-addcart");
    function buildCart(){
      var ids=[];
      mBody.querySelectorAll(".mp-size").forEach(function(s){ if(s.value) ids.push(s.value+":1"); });
      mAdd.href = ids.length ? (CART_URL + "/" + ids.join(",")) : "#";   /* relative -> market aware */
      var total = mBody.querySelectorAll(".mp").length;
      mAdd.textContent = (ids.length === total) ? "Add all to cart" : ("Add " + ids.length + " of " + total + " to cart");
      mAdd.setAttribute("aria-disabled", ids.length ? "false" : "true");
      mAdd.style.pointerEvents = ids.length ? "" : "none";
      mAdd.style.opacity = ids.length ? "" : ".5";
    }
    $$(".shopbtn[data-look]").forEach(function (btn) {
    var look = btn.getAttribute("data-look");
    /* Warm the cache on hover/focus so the modal never opens with an empty size list. */
    var warm = function () { $$("#look-" + look + " .piece").forEach(function (p) { getProduct(p.getAttribute("href")); }); };
    btn.addEventListener("pointerenter", warm, { once: true });
    btn.addEventListener("focus", warm, { once: true });

    btn.addEventListener("click", function () {
      mBody.innerHTML = "";
      $$("#look-" + look + " .piece").forEach(function (piece) {
        var href = piece.getAttribute("href");
        var row = document.createElement("div"); row.className = "mp";

        var img = document.createElement("img"); img.className = "mp-img"; img.loading = "lazy";
        var pi = piece.querySelector(".piece-img img");
        img.src = pi ? (pi.currentSrc || pi.src) : ""; img.alt = "";

        var info = document.createElement("div"); info.className = "mp-info";
        var a = document.createElement("a"); a.className = "mp-title"; a.href = href;
        a.textContent = piece.getAttribute("title") || "";

        var sel = document.createElement("select"); sel.className = "mp-size"; sel.disabled = true;
        sel.innerHTML = '<option value="">Loading sizes\u2026</option>';
        sel.addEventListener("change", buildCart);

        info.appendChild(a); info.appendChild(sel);
        row.appendChild(img); row.appendChild(info); mBody.appendChild(row);

        getProduct(href).then(function (prod) {
          sel.innerHTML = "";
          if (!prod || !prod.variants || !prod.variants.length) {   /* product gone -> degrade to a link */
            sel.innerHTML = '<option value="">Unavailable</option>';
            row.classList.add("mp--unavailable");
            buildCart(); return;
          }
          var any = false;
          prod.variants.forEach(function (v) {
            var o = document.createElement("option");
            o.value = v.available ? String(v.id) : "";   /* sold-out can never reach the cart */
            o.textContent = v.title + (v.available ? "" : " (sold out)");
            o.disabled = !v.available;
            if (v.available) any = true;
            sel.appendChild(o);
          });
          if (!any) {
            sel.innerHTML = '<option value="">Sold out</option>';
            sel.disabled = true;
            row.classList.add("mp--unavailable");
          } else {
            sel.disabled = false;
            sel.value = String(prod.variants.filter(function (v) { return v.available; })[0].id);
          }
          buildCart();
        });
      });
      buildCart();
      openModal(shopM);
    });
  });
    /* Add to cart without wiping the shopper's existing cart. Falls back to the permalink. */
    mAdd.addEventListener("click", function (e) {
      var ids = [];
      mBody.querySelectorAll(".mp-size").forEach(function (s) { if (s.value) ids.push(s.value); });
      if (!ids.length) { e.preventDefault(); return; }
      e.preventDefault();
      fetch(CART_URL + "/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        window.location.href = CART_URL;
      }).catch(function () { toast("Some items are unavailable \u2014 please try again."); });
    });

    shopM.addEventListener("click", function(e){ if(e.target===shopM) closeModal(shopM); });
    shopM.querySelector("[data-mclose]").addEventListener("click", function(){ closeModal(shopM); });
  }

  /* ---- Wishlist (localStorage) ---- */
  var WK="gg_wishlist";
  function wget(){ try{return JSON.parse(localStorage.getItem(WK))||[];}catch(e){return [];} }
  function wset(a){ try{localStorage.setItem(WK, JSON.stringify(a));}catch(e){} }
  function wcount(){ var el=$(".wishn"); if(el){ var n=wget().length; el.textContent=n?("("+n+")"):""; } }
  function whearts(){ var s=wget().map(function(x){return x.n;});
    $$(".wishheart[data-look]").forEach(function(b){
      var on = s.indexOf(b.getAttribute("data-look"))>=0;
      b.classList.toggle("saved", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    }); }
  $$(".wishheart[data-look]").forEach(function(b){
    b.addEventListener("click", function(){
      var n=b.getAttribute("data-look"), t=b.getAttribute("data-title")||("Look "+n);
      var a=wget(), i=a.map(function(x){return x.n;}).indexOf(n);
      if(i>=0){ a.splice(i,1); toast("Removed from wishlist"); }
      else {
        var im=($("#look-"+n+" .slide img")||{}).src||"";
        a.push({n:n,title:t,href:"#look-"+n,img:im}); toast("Saved to wishlist");
      }
      wset(a); whearts(); wcount();
    });
  });
  var wishP=$("#wishpanel"), wishBtn=$(".wishbtn");
  if(wishP && wishBtn){
    var wBody=wishP.querySelector(".wish-body");
    function renderWish(){
      var a=wget();
      if(!a.length){ wBody.innerHTML='<div class="wish-empty">No saved looks yet. Tap the heart on any look.</div>'; return; }
      wBody.innerHTML="";
      a.forEach(function(x){
        var row=document.createElement("div"); row.className="wi";
        var src=x.img || ($("#look-"+x.n+" .slide img")||{}).src || "";
        var img=document.createElement("img"); img.className="wi-img"; img.src=src; img.alt=x.title||("Look "+x.n); img.loading="lazy";
        var link=document.createElement("a"); link.className="wi-link"; link.href=x.href; link.textContent="Look "+x.n+" — "+x.title;
        link.addEventListener("click", function(){ closeModal(wishP); });
        var rm=document.createElement("button"); rm.className="wi-rm"; rm.type="button"; rm.setAttribute("aria-label","Remove"); rm.innerHTML="&times;";
        rm.addEventListener("click", function(){ wset(wget().filter(function(y){return y.n!==x.n;})); renderWish(); whearts(); wcount(); });
        row.appendChild(img); row.appendChild(link); row.appendChild(rm); wBody.appendChild(row);
      });
    }
    wishBtn.addEventListener("click", function(){ renderWish(); openModal(wishP); });
    wishP.addEventListener("click", function(e){ if(e.target===wishP) closeModal(wishP); });
    wishP.querySelector("[data-wclose]").addEventListener("click", function(){ closeModal(wishP); });
  }
  whearts(); wcount();

  /* ---- Share Look ---- */
  function copyText(txt){
    if(navigator.clipboard && window.isSecureContext){
      return navigator.clipboard.writeText(txt).catch(function(){ return legacyCopy(txt); });
    }
    return legacyCopy(txt);
  }
  function legacyCopy(txt){
    try{
      var ta=document.createElement("textarea");
      ta.value=txt; ta.setAttribute("readonly","");
      ta.style.position="fixed"; ta.style.top="0"; ta.style.left="0"; ta.style.opacity="0";
      document.body.appendChild(ta); ta.focus(); ta.select(); ta.setSelectionRange(0,txt.length);
      document.execCommand("copy"); document.body.removeChild(ta);
    }catch(e){}
    return Promise.resolve();
  }
  $$(".sharebtn[data-look]").forEach(function(b){
    b.addEventListener("click", function(){
      var n=b.getAttribute("data-look"), t=b.getAttribute("data-title")||("Look "+n);
      var url=location.origin+location.pathname+"#look-"+n;
      if(navigator.share && window.isSecureContext){
        navigator.share({title:t, url:url}).catch(function(){ copyText(url).then(function(){toast("Link copied");}); });
      } else {
        copyText(url).then(function(){toast("Link copied");});
      }
    });
  });

  document.addEventListener("keydown", function(e){
    if(e.key==="Escape"){ if(shopM&&!shopM.hidden)closeModal(shopM); if(wishP&&!wishP.hidden)closeModal(wishP); }
  });

  /* Anchor jumps (#look-N / #cat-*). Replaces html{scroll-behavior:smooth}, the section's only
     global CSS escape. scroll-margin-top still applies via --nav-h on GG. */
  GG.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || !a.hash) return;
    var t = document.getElementById(decodeURIComponent(a.hash.slice(1)));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: sb(), block: "start" });
    if (history.pushState) history.pushState(null, "", a.hash);
  });

  window.addEventListener("popstate", function () {
    if (!location.hash) return;
    var t = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (t) t.scrollIntoView({ behavior: "auto", block: "start" });
  });
  }

  boot();
  document.addEventListener("shopify:section:load", boot);   /* theme editor re-render */
})();
